
// 发布面试题相关请求
import request from '@/utils/request'

// 发布面试题报文
export const questionBandAdd=(form)=>{
    return request.post(
        '/questionBand/questionBandAdd',
        form
    )
}